import React from "react";
import styled from "styled-components";
import { Content } from "../Content";
import { primaryGradient, secondaryGradient } from "../GradientBox";
import { mobileQuery } from "../MediaQuery";

export const HomeSection: React.FC<{
  gradient?: boolean;
  secondaryGradient?: boolean;
  children?: React.ReactNode;
}> = (props) => (
  <Wrapper
    gradient={props.gradient ?? false}
    secondaryGradient={props.secondaryGradient ?? false}
  >
    <Content>{props.children}</Content>
  </Wrapper>
);

const Wrapper = styled.div<{ gradient: boolean; secondaryGradient: boolean }>`
  ${(props) =>
    props.gradient &&
    `
    background: ${primaryGradient};
  `}
  ${(props) =>
    props.secondaryGradient &&
    `
    background: ${secondaryGradient};
  `}
  padding: 50px 0;

  ${mobileQuery`
    padding: 34px 0;
  `}
`;
